const __WEBPACK_NAMESPACE_OBJECT__ = require("live/components/ui/admin/web-settings-card");